/* ═══════════════════════════════════════
   SAGE & VEDA — THEME JS
   Global behaviors: gallery, lightbox, variant sync
═══════════════════════════════════════ */
(function () {
  'use strict';

  /* ── Lazy image fade-in ── */
  if ('IntersectionObserver' in window) {
    var imgObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          var img = e.target;
          img.classList.add('loaded');
          imgObserver.unobserve(img);
        }
      });
    }, { rootMargin: '200px' });
    document.querySelectorAll('img[loading="lazy"]').forEach(function (img) {
      if (img.complete) { img.classList.add('loaded'); }
      else { imgObserver.observe(img); }
    });
  } else {
    document.querySelectorAll('img[loading="lazy"]').forEach(function (img) {
      img.classList.add('loaded');
    });
  }

  /* ── Product Gallery Custom Element ── */
  if (!customElements.get('sv-product-gallery')) {
    customElements.define('sv-product-gallery', class extends HTMLElement {
      connectedCallback() {
        this._slides   = this.querySelectorAll('.sv-gallery__slide');
        this._thumbs   = this.querySelectorAll('.sv-gallery__thumb');
        this._dots     = this.querySelectorAll('.sv-gallery__dot');
        this._prevBtn  = this.querySelector('[data-gallery-prev]');
        this._nextBtn  = this.querySelector('[data-gallery-next]');
        this._current  = 0;

        if (this._prevBtn) this._prevBtn.addEventListener('click', () => this.go(this._current - 1));
        if (this._nextBtn) this._nextBtn.addEventListener('click', () => this.go(this._current + 1));

        this._thumbs.forEach((t, i) => t.addEventListener('click', () => this.go(i)));
        this._dots.forEach((d, i)   => d.addEventListener('click', () => this.go(i)));

        /* Switch slide when variant changes */
        document.addEventListener('sv:variant:change', (e) => {
          var mediaId = e.detail && e.detail.featuredMediaId;
          if (!mediaId) return;
          var idx = Array.from(this._slides).findIndex(s => s.dataset.mediaId === String(mediaId));
          if (idx !== -1) this.go(idx);
        });

        /* Touch swipe */
        var startX = 0;
        var stage = this.querySelector('.sv-gallery__stage');
        if (stage) {
          stage.addEventListener('touchstart', e => { startX = e.touches[0].clientX; }, { passive: true });
          stage.addEventListener('touchend',   e => {
            var dx = e.changedTouches[0].clientX - startX;
            if (Math.abs(dx) > 40) dx < 0 ? this.go(this._current + 1) : this.go(this._current - 1);
          });
        }
      }

      go(index) {
        var total = this._slides.length;
        if (!total) return;
        index = ((index % total) + total) % total;
        this._slides.forEach((s, i) => {
          s.classList.toggle('is-active', i === index);
          s.setAttribute('aria-hidden', i !== index ? 'true' : 'false');
        });
        this._thumbs.forEach((t, i) => t.classList.toggle('is-active', i === index));
        this._dots.forEach((d, i)   => d.classList.toggle('is-active', i === index));
        this._current = index;
      }
    });
  }

  /* ── Add to Cart Custom Element ── */
  if (!customElements.get('sv-add-to-cart')) {
    customElements.define('sv-add-to-cart', class extends HTMLElement {
      connectedCallback() {
        var btn = this.querySelector('[data-atc-btn]');
        var select = document.querySelector('[data-variant-select]');
        if (!btn) return;

        btn.addEventListener('click', (event) => {
  event.preventDefault();
  if (btn.disabled || btn.dataset.state === 'loading') return;
          var variantId = select ? select.value : btn.closest('[data-product-id]')?.dataset?.productId;
          if (!variantId) return;
          var qtyInput = this.querySelector('[data-qty-input]');
          var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;

          btn.dataset.state = 'loading';
          var btnText = btn.querySelector('[data-btn-text]');
          var spinner = btn.querySelector('[data-spinner]');
          if (spinner) spinner.hidden = false;
          var orig = btnText ? btnText.textContent : '';

          /* Check subscribe state */
          var subRadio = document.querySelector('input[name^="pt_"][value="subscribe"]:checked');
          var isSubscribe = !!subRadio;
          var freqSelect = document.querySelector('.sv-subscribe__freq-select');
          var freqDays = freqSelect ? freqSelect.value : '30';
          var payload = { id: variantId, quantity: qty };
          if (isSubscribe) {
            if (freqSelect && freqSelect.dataset.nativePlans === 'true' && freqSelect.value) {
              payload.selling_plan = parseInt(freqSelect.value, 10);
            } else {
              payload.properties = {
                'Purchase Type': 'Subscribe & Save',
                'Delivery Frequency': 'Every ' + freqDays + ' days'
              };
            }
          }

          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: JSON.stringify(payload)
          })
          .then(r => r.json())
          .then(data => {
            if (data.status) throw new Error(data.description || 'Error');
            btn.dataset.state = 'success';
            if (spinner) spinner.hidden = true;
            if (btnText) btnText.textContent = 'ADDED \u2713';
            document.dispatchEvent(new CustomEvent('sv:cart:updated'));
            if (window.svOpenCartDrawer) window.svOpenCartDrawer();
            setTimeout(() => {
              btn.dataset.state = '';
              if (btnText) btnText.textContent = orig;
            }, 2000);
          })
          .catch(() => {
  btn.dataset.state = 'error';
  if (spinner) spinner.hidden = true;
  if (btnText) btnText.textContent = 'ERROR — TRY AGAIN';
  setTimeout(() => {
    btn.dataset.state = '';
    if (btnText) btnText.textContent = orig;
  }, 2500);
});
        });
      }
    });
  }

  /* ── Variant selector ── */
  document.addEventListener('change', function (e) {
    if (e.target.matches('[data-option-input]')) syncVariant();
  });

  function syncVariant() {
    var select = document.querySelector('[data-variant-select]');
    if (!select) return;

    /* Collect checked values per option position */
    var vals = {};
    document.querySelectorAll('[data-option-input]:checked').forEach(function (inp) {
      vals[inp.dataset.optionPosition] = inp.value;
    });
    var valArr = Object.keys(vals).sort().map(function (k) { return vals[k]; });

    /* Find option whose data-options matches */
    var match = Array.from(select.options).find(function (opt) {
      var optVals = (opt.dataset.options || '').split('|');
      return valArr.length && valArr.every(function (v, i) { return optVals[i] === v; });
    });

    if (!match) return;

    select.value = match.value;
    select.dispatchEvent(new Event('change', { bubbles: true }));

    var v = {};
    try { v = JSON.parse(match.dataset.variant || '{}'); } catch (e) {}

    var featuredMediaId = match.dataset.featuredMediaId || null;
    var imageId = match.dataset.imageId || null;
    document.dispatchEvent(new CustomEvent('sv:variant:change', {
      detail: { variant: v, featuredMediaId: featuredMediaId, imageId: imageId }
    }));

    /* Update ATC + subscribe price displays */
    var rawPrice = parseInt(match.dataset.price, 10); /* in cents */
    var price = (rawPrice / 100)
      .toLocaleString('en-US', { style: 'currency', currency: 'USD' });

    /* Subscribe price: use selling_plan_allocation price from data attr if available, else fall back to % calc */
    var rawSubPrice = parseInt(match.dataset.subPrice, 10);
    var subPrice;
    if (rawSubPrice > 0) {
      subPrice = (rawSubPrice / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' });
    } else {
      var subPctEl = document.querySelector('.sv-subscribe__save-badge');
      var subPct = subPctEl ? parseInt(subPctEl.textContent.replace(/[^0-9]/g, ''), 10) || 15 : 15;
      subPrice = ((rawPrice / 100) * (100 - subPct) / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' });
    }
    var subRadio = document.querySelector('input[name^="pt_"][value="subscribe"]:checked');
    var isSubscribe = !!subRadio;
    var atcPrice = isSubscribe ? subPrice : price;
    document.querySelectorAll('sv-add-to-cart [data-atc-btn]').forEach(function (button) {
  var available = v.available === true;
  button.disabled = !available;
  button.setAttribute('aria-disabled', String(!available));

  if (button.dataset.state !== 'loading') {
    delete button.dataset.state;

    var text = button.querySelector('[data-btn-text]');
    if (text) {
      text.textContent = available
        ? 'ADD TO CART — ' + atcPrice
        : 'SOLD OUT';
    }
  }
});

    document.querySelectorAll('[data-btn-text]').forEach(function (el) {
      if (/ADD TO CART|SUBSCRIBE/.test(el.textContent)) {
        el.textContent = el.textContent.replace(/\$[\d,.]+/, atcPrice);
      }
    });
    document.querySelectorAll('[data-one-time-price]').forEach(function (el) {
      el.textContent = price;
    });

    /* Update subscribe price-was (full price) and price-now (discounted) */
    document.querySelectorAll('.sv-subscribe__price-was').forEach(function (el) {
      el.textContent = price;
    });
    document.querySelectorAll('.sv-subscribe__price-now').forEach(function (el) {
      el.textContent = subPrice;
    });

    /* Update option card active states — input is inside the label */
    document.querySelectorAll('[data-option-input]').forEach(function (inp) {
      var card = inp.closest('.sv-pdp__option-card');
      if (card) card.classList.toggle('is-active', inp.checked);
    });
  }

  /* ── Subscribe toggle → update ATC button price ── */
  document.addEventListener('change', function (e) {
    if (!e.target.matches('input[name^="pt_"]')) return;
    var variantSelect = document.querySelector('[data-variant-select]');
    if (!variantSelect) return;
    var selectedOpt = Array.from(variantSelect.options).find(function (o) { return o.value === variantSelect.value; });
    if (!selectedOpt) return;
    var rawPrice = parseInt(selectedOpt.dataset.price, 10);
    if (isNaN(rawPrice)) return;
    var price = (rawPrice / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' });
    var rawSubPrice = parseInt(selectedOpt.dataset.subPrice, 10);
    var subPrice;
    if (rawSubPrice > 0) {
      subPrice = (rawSubPrice / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' });
    } else {
      var subPctEl = document.querySelector('.sv-subscribe__save-badge');
      var subPct = subPctEl ? parseInt(subPctEl.textContent.replace(/[^0-9]/g, ''), 10) || 15 : 15;
      subPrice = ((rawPrice / 100) * (100 - subPct) / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' });
    }
    var isSubscribe = e.target.value === 'subscribe';
    var atcPrice = isSubscribe ? subPrice : price;
    document.querySelectorAll('[data-btn-text]').forEach(function (el) {
      if (/ADD TO CART|SUBSCRIBE/.test(el.textContent)) {
        el.textContent = el.textContent.replace(/\$[\d,.]+/, atcPrice);
      }
    });
  });

  /* ── Lightbox ── */
  var lightbox = document.querySelector('[data-lightbox]');
  var lightboxImg = lightbox && lightbox.querySelector('[data-lightbox-img]');

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-lightbox-trigger]');
    if (!trigger || !lightbox) return;
    var src = trigger.dataset.src || trigger.querySelector('img')?.src;
    var alt = trigger.dataset.alt || '';
    if (!src) return;
    lightboxImg.src = src;
    lightboxImg.alt = alt;
    lightbox.classList.add('is-open');
    lightbox.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  });

  if (lightbox) {
    lightbox.querySelector('[data-lightbox-close]')?.addEventListener('click', closeLightbox);
    lightbox.addEventListener('click', function (e) {
      if (e.target === lightbox) closeLightbox();
    });
  }
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeLightbox();
  });

  function closeLightbox() {
    if (!lightbox) return;
    lightbox.classList.remove('is-open');
    lightbox.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  /* ── Scroll Reveal ── */
  (function () {
    if (!('IntersectionObserver' in window)) {
      document.querySelectorAll('[data-reveal]').forEach(function (el) {
        el.classList.add('sv-revealed');
      });
      return;
    }
    var revealObs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('sv-revealed');
          revealObs.unobserve(e.target);
        }
      });
    }, { threshold: 0.12 });
    document.querySelectorAll('[data-reveal]').forEach(function (el) {
      revealObs.observe(el);
    });
  })();

  /* ── Fade-up Reveal (.fade-up → .is-visible) ── */
  (function () {
    if (!('IntersectionObserver' in window)) {
      document.querySelectorAll('.fade-up').forEach(function (el) {
        el.classList.add('is-visible');
      });
      return;
    }
    var fadeObs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('is-visible');
          fadeObs.unobserve(e.target);
        }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' });
    document.querySelectorAll('.fade-up').forEach(function (el) {
      fadeObs.observe(el);
    });
  })();

  /* ── Counter Animation ── */
  (function () {
    if (!('IntersectionObserver' in window)) return;
    function runCounter(el) {
      var raw = el.textContent.trim();
      var num = parseFloat(raw);
      if (isNaN(num)) return;
      var suffix = raw.replace(/[\d.]/g, '');
      var duration = 1400;
      var startTime = null;
      function step(ts) {
        if (!startTime) startTime = ts;
        var progress = Math.min((ts - startTime) / duration, 1);
        var eased = 1 - Math.pow(1 - progress, 3);
        el.textContent = Math.round(eased * num) + suffix;
        if (progress < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    }
    var counterObs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          runCounter(e.target);
          counterObs.unobserve(e.target);
        }
      });
    }, { threshold: 0.5 });
    document.querySelectorAll('[data-count-up]').forEach(function (el) {
      counterObs.observe(el);
    });
  })();

})();
